import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  FormControl,
  FormGroup,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  DropDownOptions,
  ExtendedMaterialGroup,
  ExtendedMaterialSubGroup,
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import SmlDeviationReasonJSON from 'src/app/data/constants/SmlDeviationReasons.json';
import CriticalityCodeJSON from 'src/app/data/constants/Criticality.json';
import WorkmanshipStandardJSON from 'src/app/data/constants/WorkmanshipStandard.json';
import {
  Observable,
  Subject,
  lastValueFrom,
  map,
  takeUntil,
} from 'rxjs';
import COTSJSON from 'src/app/data/constants/CotsCustomized.json';
import { ActivatedRoute } from '@angular/router';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { StandardMaterial, Brand } from 'src/app/shared/models/database-models';
import { environment } from 'src/environments/environment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from 'src/app/data/constants/Data';
import { NoticeService } from 'src/app/core/services/notice.service';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import moment from 'moment';
import { getInitialStoreDropdownsCopy } from 'src/app/core/store/dropDown.reducer';
@Component({
  selector: 'app-item-info',
  templateUrl: './item-info.component.html',
  styleUrls: ['./item-info.component.scss'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }],
})
export class ItemInfoComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  addItemForm!: FormGroup;
  @Input() purchaseType?: string;
  @Input() isReadOnly: boolean = false;
  itemId: number = 1;
  displayItemNumber: number = 0;
  partModelNo: string = '';

  //Add Item Form
  //Description
  savedDesc: string = '';
  //Obsolete
  savedObsolete: boolean = false;
  //SML
  SMLdropdown: DropDownOptions[] = [];
  SMLControl!: FormControl;
  //Cots
  COTSdropdown: DropDownOptions[] = [];
  COTSControl!: FormControl;
  //Brand/OEM
  BOemdropdown: DropDownOptions[] = [];
  BOemControl!: FormControl;
  isBrandOEMRequired: boolean = false;
  BrandOEMNameOther: any = { id: '', value: '' };
  //Material Group
  MatGpdropdown: DropDownOptions[] | ExtendedMaterialGroup[] = [];
  selectedMatGp!: DropDownOptions;
  MatGpControl!: FormControl;
  //Material Sub Group
  MatSGpdropdown: DropDownOptions[] | ExtendedMaterialSubGroup[] = [];
  MatSGpControl!: FormControl;
  //Workmanship Standard
  WorkSddropdown: DropDownOptions[] = [];
  WorkSdControl!: FormControl;
  PlannedDeliveryDate!: FormControl;
  isWorkSdRequired: boolean = false;
  //Criticality Code
  CritCodedropdown: DropDownOptions[] = [];
  CritCodeControl!: FormControl;
  isCritialityRequired: boolean = false;
  // part no
  PartNoControl!: FormControl;
  //Item description
  itemDescriptionControl!: FormControl;
  itemDescriptionPlaceHolder: string = 'Eg. 10ml of Sodium Nitrate';

  minDate: Date = new Date();

  isModelPartNoValidated: boolean = false;
  partModelOption: string = 'Yes';
  choices = ['Yes', 'No'];
  isModelNoFinishedChecking: boolean = false;
  isPartNoInSML: boolean = false;
  isAutoSet: boolean = false;
  actionChosen: boolean = false;
  checkButtonTxt: string = 'Check Part No.';
  // store dropdowns
  IsExemptedAOR: boolean = false
  StoreDropdownContainer: StoreDropdowns = getInitialStoreDropdownsCopy();

  // conditions for user to fill up
  smlConditions: StandardMaterial = {
    MainMaterialGroupCode: '',
    MaterialGroupCode: '',
    Description: '',
    IsCOTSCustRequired: false,
    CotsCustomized: '',
    IsCOTSChangable: false,
    IsIPCClassRequired: false,
    IsIPCClassChangable: false,
    WorkmanshipStandard: '',
    IsObsolete: false,
  };

  // conditions for material Sub Group changes

  materialSubgroupConditions: ExtendedMaterialSubGroup = {
    id: '',
    value: '',
    Code: '',
    Name: '',
    ParentGroupCode: '',
    IsCOTSCustRequired: true, //customised
    IsBrandRequired: false, // oem
    IsPartNumberRequired: false,
    IsDevFromSMLRequired: false,
    IsCompModuleRequired: false,
    IsBatchLotRequired: false,
    IsGRRequired: false,
    IsSVRequired: false,
    IsStorageMediaRequired: false,
    IsIPCClassRequired: false, // workmanship value
    IsSupportingDocumentRequiredAtGA: false,
    IsCoverageDateRequired: false,
    IsCriticalityRequired: false,
    IsIPCClassChangable: false,
    DefaultIPCClass: '',
    DefaultCOTS: '',
    IsCOTSChangable: false,
    IsGEWCA: false,
    IsExemptedAOR: false,
    RestrictedITProductPolicy: null,
    HasVendor: false
  };

  destroy$: Subject<boolean> = new Subject<boolean>();
  mode: string = 'add';
  itemNo: number = 0;
  form: IItemToRequest[] = [];
  originalSubGroup: ExtendedMaterialSubGroup[] = [];
  isObsolete: boolean = false;
  constructor(
    private store: Store<{ form: MyPurchaseForm; dp: StoreDropdowns }>,
    private route: ActivatedRoute,
    private backendService: BackendApiService,
    public noticeService: NoticeService,
  ) {
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }

    // getting data from JSON files
    SmlDeviationReasonJSON.forEach((sml) => {
      if (sml.isActive) {
        this.SMLdropdown.push({ id: sml.id, value: sml.reason });
      }
    });
    WorkmanshipStandardJSON.forEach((wkman) => {
      if (wkman.isActive) {
        this.WorkSddropdown.push({ id: wkman.Code, value: wkman.Name });
      }
    });
    CriticalityCodeJSON.forEach((critical) => {
      if (critical.isActive) {
        this.CritCodedropdown.push({ id: critical.id, value: critical.name });
      }
    });

    COTSJSON.forEach((cots) => {
      if (cots.isActive) {
        this.COTSdropdown.push({ id: cots.Value, value: cots.Name });
      }
    });
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.StoreDropdownContainer = dp;

        this.loadData();
      });
  }
  clearInput() {
    const inputControl = this.addItemForm.get('BrandOEMNameCustom') as FormControl;
    inputControl.setValue(''); // Clear the input value
  }
  async ngOnInit(): Promise<void> {
    
    // controls
    this.PartNoControl = this.addItemForm.controls[
      'PartModelNumber'
    ] as FormControl;
    // this.SMLControl = this.addItemForm.controls["SMLReasonId"] as FormControl;
    this.COTSControl = this.addItemForm.controls['isCOTS'] as FormControl;
    this.itemDescriptionControl = this.addItemForm.controls[
      'ItemDescription'
    ] as FormControl;
    this.BOemControl = this.addItemForm.controls["BrandOEMName"] as FormControl;
    this.MatGpControl = this.addItemForm.controls[
      'MaterialGroupId'
    ] as FormControl;
    this.MatSGpControl = this.addItemForm.controls[
      'MaterialSubGroupId'
    ] as FormControl;
    this.PlannedDeliveryDate = this.addItemForm.controls[
      'PlannedDeliveryDate'
    ] as FormControl;
    this.WorkSdControl = this.addItemForm.controls[
      'WorkmanshipId'
    ] as FormControl;

    this.BOemControl = this.addItemForm.controls["BrandOEMName"] as FormControl;

    this.BOemControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((v) => {
        this.BrandOEMNameOther = v;
        if (v && Object.hasOwn(v,'id') && v.id === 'OTH' && !this.addItemForm.get('BrandOEMNameCustom')?.value) {
          this.setBrandOEMNameCustom('no preference');
        }
      });


    // this.CritCodeControl = this.addItemForm.controls["CriticalityId"] as FormControl;
    this.addItemForm.controls['BrandOEMName'].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((v) => {
        this.BrandOEMNameOther = v
      });
    this.PartNoControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((v) => {
        if (!this.isAutoSet) {
          this.checkButtonTxt = 'Check Part No';
          this.isModelPartNoValidated = false;
          this.isModelNoFinishedChecking = false;
          this.actionChosen = false;
        } else {
          this.isAutoSet = false;
        }
      });
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.form = form.ItemList;
        if (!this.addItemForm) return;
        this.isAutoSet = true;
        if (this.mode == 'edit' && this.form.length !== 0) {

          let item = this.form[this.itemNo - 1].AddItems;
          if (item.MaterialSubGroupId?.Code) {
            await this.BrandCodeFromVendorMaterialGroup(item.MaterialSubGroupId?.Code)
          }

          this.IsExemptedAOR = item.MaterialSubGroupId?.IsExemptedAOR ?? false;
          this.addItemForm.setValue({
            itemId: item.itemId,
            displayItemNumber: item.displayItemNumber,
            PartModelNumber: item.PartModelNumber,
            IsSML: item.IsSML,
            SMLReasonId: item.SMLReasonId
              ? this.SMLdropdown.find(
                (sml) => sml.value == item.SMLReasonId?.value
              )
              : null,
            isCOTS: item.isCOTS ? item.isCOTS : null,
            isSingleBudget: item.isSingleBudget, //this is the real value here
            ItemDescription: item.ItemDescription,
            PlannedDeliveryDate: moment(item.PlannedDeliveryDate),
            BrandOEMName: item.BrandOEMName
              ? this.BOemdropdown.find(
                (brand) => brand.value == item.BrandOEMName?.value
              )
              : null,
            BrandOEMNameCustom: item.BrandOEMNameCustom,
            MaterialGroupId: item.MaterialGroupId,
            MaterialSubGroupId: item.MaterialSubGroupId,
            WorkmanshipId: item.WorkmanshipId
              ? this.WorkSddropdown.find(
                (wkman) => wkman.value == item.WorkmanshipId?.value
              )
              : null,
            CriticalityId: item.CriticalityId
              ? this.CritCodedropdown.find(
                (crit) => crit.value == item.CriticalityId?.value
              )
              : null,
            PurchaseItemId: item.PurchaseItemId,
          });
          if (item.PartModelNumber != '' && item.PartModelNumber) {
            this.partModelOption = 'Yes';
            await this.validatePartModelNo();
            this.actionChosen = true;
          } else {
            this.partModelOption = 'No';
            this.isModelPartNoValidated = true;
          }
          this.materialSubgroupConditions = this.MatSGpControl.value;
          this.filterMaterialGroup();
        } else {
          console.log(this.form);
          const maxDisplayItemNumber = Math.max(0, ...this.form.map(item => item?.AddItems?.displayItemNumber ?? 0));
          this.addItemForm.setValue({
            itemId: this.form.length + 1,
            displayItemNumber: maxDisplayItemNumber + 1,
            PartModelNumber: '',
            SMLReasonId: null,
            isCOTS: null,
            IsSML: null,
            isSingleBudget: null,
            ItemDescription: null,
            PlannedDeliveryDate: null,
            BrandOEMName: null,
            BrandOEMNameCustom: 'no preference',
            MaterialGroupId: null,
            MaterialSubGroupId: null,
            WorkmanshipId: null,
            CriticalityId: null,
            PurchaseItemId: null,
          });
        }
        this.isAutoSet = false;
      });
  }
  setBrandOEMNameCustom(value: string): void {
    const inputControl = this.addItemForm.get('BrandOEMNameCustom') as FormControl;
    inputControl.setValue(value);
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly']) {
      if (changes['isReadOnly'].currentValue == true) {
        this.addItemForm.disable();
      } else {
        this.addItemForm.enable();
      }
    }
  }

  resetForm() {
    this.addItemForm.setValue({
      ...this.addItemForm.value,
      PartModelNumber: '',
      SMLReasonId: null,
      isCOTS: null,
      isSingleBudget: null, //this is the real value here
      ItemDescription: null,
      PlannedDeliveryDate: new Date(),
      BrandOEMName: null,
      MaterialGroupId: null,
      MaterialSubGroupId: null,
      WorkmanshipId: null,
      CriticalityId: null,
    });
    this.isModelPartNoValidated = false;
    this.isModelNoFinishedChecking = false;
    this.isPartNoInSML = false;
    this.isObsolete = false;
  }
  continueForm(event: any) {
    event.srcElement.disabled = true;
    console.log(this.smlConditions);
    this.isAutoSet = true;
    this.addItemForm.setValue({
      ...this.addItemForm.value,
      isCOTS:
        this.COTSdropdown.find(
          ({ value }) => value == this.smlConditions.CotsCustomized
        ) ?? null,
      ItemDescription: this.smlConditions.Description,
      MaterialGroupId:
        this.MatGpdropdown.find(
          ({ value }) => value == this.smlConditions.MainMaterialGroupCode
        ) ?? null,
      MaterialSubGroupId:
        this.MatSGpdropdown.find(
          ({ value }) => value == this.smlConditions.MaterialGroupCode
        ) ?? null,
      WorkmanshipId:
        this.WorkSddropdown.find(
          ({ id }) => id == this.smlConditions.WorkmanshipStandard
        ) ?? null,
    });
    this.isAutoSet = false;
    this.actionChosen = true;

  }

  onMaterialGroupChange(event: ExtendedMaterialGroup) {
    if (!this.isAutoSet) this.MatSGpControl.setValue(null);
    if (event) {
      this.MatSGpdropdown = this.originalSubGroup.filter(
        (subgroup) => subgroup.ParentGroupCode == event.Code
      );
    }
  }
  resetSubGroup() {
    this.MatSGpdropdown = this.originalSubGroup;
  }

  filterMaterialGroup() {
    if (this.MatGpControl.value?.Code)
    this.MatSGpdropdown = this.originalSubGroup.filter(
      (subgroup) => subgroup.ParentGroupCode == this.MatGpControl.value.Code
    );
  }

  async onMaterialSubGroupChange(event: ExtendedMaterialSubGroup | null) {
    if (event != null && !this.isAutoSet) {
      let MaterialGroupToChoose = this.MatGpdropdown.find(
        (mg) => mg.id == event.ParentGroupCode
      );
      this.MatGpControl.setValue(MaterialGroupToChoose);
      this.materialSubgroupConditions = {
        ...event,
      };
      this.IsExemptedAOR = this.materialSubgroupConditions.IsExemptedAOR ?? false;
      this.COTSControl.setValue(
        this.COTSdropdown.find(({ id }) => this.materialSubgroupConditions.DefaultCOTS == id) ?? null
      );
      this.WorkSdControl.setValue(
        this.WorkSddropdown.find(({ id }) => this.materialSubgroupConditions.DefaultIPCClass == id) ?? null
      );
      await this.BrandCodeFromVendorMaterialGroup(this.materialSubgroupConditions.Code)
    }
  }
  async BrandCodeFromVendorMaterialGroup(materialGroupCode: string) {
    let oemData: Brand[] = await lastValueFrom(this.backendService.getBrands(materialGroupCode));
    const oemOptions: DropDownOptions[] = [];
    oemData.forEach((option: Brand) => {
      let obj = { id: option.Code, value: option.Name };
      oemOptions.push(obj);
    });
    this.BOemdropdown = oemOptions
    let BrandCode = this.BOemControl.getRawValue();
    if (BrandCode) {
      this.BOemControl.setValue(
        this.BOemdropdown.find(
          ({ id }) =>
            BrandCode.id == id
        ) ?? null
      );
    }
  }
  onPartModelOptChange(event: any) {
    console.log(event);
    if (event.value == 'No') {
      this.isModelPartNoValidated = true;
      this.isAutoSet = true;
      this.PartNoControl.setValue('');
    } else if (event.value == 'Yes') {
      this.isModelPartNoValidated = false;
    } else {
      this.isModelPartNoValidated = false;
    }
  }

  async validatePartModelNo() {
    if (this.PartNoControl.value == '') return;
    this.checkButtonTxt = 'Checking';
    this.isModelNoFinishedChecking = false;

    try {
      let partInfo: any = await lastValueFrom(
        this.backendService.getObsoletePart(this.PartNoControl.value)
      );
      this.isObsolete = partInfo.ObsoletePartExist;
      this.isPartNoInSML = partInfo.SMLPartNoExist;

      this.addItemForm.get('IsSML')?.setValue(partInfo.SMLPartNoExist);

      let SMLData = await lastValueFrom(
        this.backendService.getSML(this.PartNoControl.value)
      );
      if (!SMLData.MainMaterialGroupCode) throw Error('no in sml');
      this.smlConditions = SMLData;
      this.isModelPartNoValidated = true;
      this.isModelNoFinishedChecking = true;
      this.checkButtonTxt = 'Checked';
    } catch (e: any) {
      this.isModelPartNoValidated = true;
      this.isModelNoFinishedChecking = true;
      if (e.status == 400) {
        this.isPartNoInSML = false;
        this.checkButtonTxt = 'Checked';
      } else {
        alert('server error');
      }
    }
  }

  loadData() {
    // retrieve MG/MSG data
    this.originalSubGroup = this.StoreDropdownContainer
      .MaterialSubGroup as ExtendedMaterialSubGroup[];
    this.MatSGpdropdown = this.StoreDropdownContainer.MaterialSubGroup;
    this.MatGpdropdown = this.StoreDropdownContainer.MaterialGroup;
    this.BOemdropdown = this.StoreDropdownContainer.OEM;
  }

  goMaterialExcelURL() {
    const url = environment.mmsmaterialURL;
    window.open(url, '_blank');
  }

  public get alertType(): typeof AlertType {
    return AlertType
  }

  public getITProductPolicyNoticeObservable(materialSubgroupConditions: ExtendedMaterialSubGroup) {
    if (!materialSubgroupConditions.RestrictedITProductPolicy) {
      return null;
    }

    const notice$ = this.getBaseNoticeObservable(materialSubgroupConditions.RestrictedITProductPolicy.toLowerCase());

    if (!notice$) return null;

    return notice$.pipe(
      map((noticeData: any) => {
        const matchedNote =
        noticeData.data?.find(
          (note: any) => note.MaterialSubGroupCode === materialSubgroupConditions.Code
        ) ||
        noticeData.data?.find(
          (note: any) => note.MaterialSubGroupCode === '*'
        ) ||
        (noticeData.data?.length === 1 ? noticeData.data[0] : null);

        return {
          ...noticeData,
          data: matchedNote ?? null,
        };
      })
    );
  }

  private getBaseNoticeObservable(policyType: string): Observable<any> | null {
    switch (policyType) {
      case 'cat1':
        return this.noticeService.ITProductPolicyCat1Notice$;
      case 'cat2':
        return this.noticeService.ITProductPolicyCat2Notice$;
      default:
        return this.noticeService.ITProductPolicyCat1Notice$;
    }
  }

  isMaterialSubGroupBelongingToMMS(materialSubGroupObj: ExtendedMaterialSubGroup) {
    return materialSubGroupObj?.Code === environment.airTicketMaterialGroupCode;
  }
}

interface SMLConditions {
  CotsCustomized: any;
  IsCOTSChangable: boolean;
  IsIPCClassChangable: boolean;
  IsIPCClassRequired: boolean;
  IsObsolete: boolean;
  WorkmanshipStandard: any;
  isCOTSCustRequired: boolean;
}
